/**
 * Marquee sponzorjev v headerju ([data-sponsors-marquee]).
 *
 * Izmeri naravno širino ene kopije logotipov proti razpoložljivi širini viewporta:
 * - gre v širino → statično (centrirano s CSS), brez klonov;
 * - ne gre → doda klon vsebine (aria-hidden) in razred .is-marquee → CSS animacija
 *   translateX(-50%) v neskončni zanki; hitrost je konstantna (px/s), trajanje se
 *   izračuna iz širine kopije.
 * ResizeObserver na viewportu in tracku pokrije resize, nalaganje slik in skrčen
 * header (.scrolled). prefers-reduced-motion → brez animacije (ročni scroll iz CSS).
 *
 * Stili: src/styles/_sponsors-marquee.scss
 */

const SPEED_PX_PER_S = 40
const MIN_DURATION_S = 8
const TOUCH_RESUME_MS = 1500

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

function setup(viewport) {
	const track = viewport.querySelector('.sponsors-marquee__track')
	if (!track || !track.children.length) return

	const originals = Array.from(track.children)
	let clones = []
	let resumeTimer = null

	const availableWidth = () => {
		const cs = getComputedStyle(viewport)
		return viewport.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)
	}

	// širina ene kopije (transform ne vpliva na getBoundingClientRect().width)
	const copyWidth = () => track.getBoundingClientRect().width / (clones.length ? 2 : 1)

	const disable = () => {
		if (clones.length) {
			clones.forEach((c) => c.remove())
			clones = []
		}
		viewport.classList.remove('is-marquee', 'is-paused')
		viewport.style.removeProperty('--sponsors-marquee-duration')
	}

	const enable = (width) => {
		if (!clones.length) {
			clones = originals.map((el) => {
				const clone = el.cloneNode(true)
				clone.setAttribute('aria-hidden', 'true')
				clone.querySelectorAll('a, button').forEach((f) => f.setAttribute('tabindex', '-1'))
				return clone
			})
			track.append(...clones)
		}
		// trajanje nastavi samo ob vklopu — sprememba med animacijo povzroči preskok
		if (!viewport.classList.contains('is-marquee')) {
			const duration = Math.max(MIN_DURATION_S, width / SPEED_PX_PER_S)
			viewport.style.setProperty('--sponsors-marquee-duration', duration.toFixed(1) + 's')
			viewport.classList.add('is-marquee')
		}
	}

	const update = () => {
		if (reduceMotion.matches) return disable()
		const width = copyWidth()
		if (width <= availableWidth() + 1) disable()
		else enable(width)
	}

	// pavza ob dotiku (da je link lažje zadeti) in ob fokusu s tipkovnico
	const pause = () => {
		clearTimeout(resumeTimer)
		viewport.classList.add('is-paused')
	}
	const resumeLater = () => {
		clearTimeout(resumeTimer)
		resumeTimer = setTimeout(() => viewport.classList.remove('is-paused'), TOUCH_RESUME_MS)
	}
	viewport.addEventListener('touchstart', pause, { passive: true })
	viewport.addEventListener('touchend', resumeLater, { passive: true })
	viewport.addEventListener('touchcancel', resumeLater, { passive: true })
	viewport.addEventListener('focusin', pause)
	viewport.addEventListener('focusout', () => viewport.classList.remove('is-paused'))

	if ('ResizeObserver' in window) {
		// rAF: DOM spremembe v RO callbacku (kloni) bi sprožile "ResizeObserver loop" opozorilo
		const ro = new ResizeObserver(() => requestAnimationFrame(update))
		ro.observe(viewport)
		ro.observe(track)
	} else {
		window.addEventListener('resize', update)
		window.addEventListener('load', update)
	}

	if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', update)
	else if (reduceMotion.addListener) reduceMotion.addListener(update)

	update()
}

export default {
	init() {
		document.querySelectorAll('[data-sponsors-marquee]').forEach(setup)
	},
}
